module.exports = __webpack_public_path__ + "img/suntec-cover.ca4693f0.jpg";